import { render, staticRenderFns } from "./DraftsList.vue?vue&type=template&id=47f57e22"
import script from "./DraftsList.vue?vue&type=script&lang=js"
export * from "./DraftsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports